import {useTranslation} from 'react-i18next';
import MainScreenButton from '../../../../../components/forms/mainScreenButton';
import React from 'react';
import {useDispatch} from 'react-redux';
import {openPatientForm} from '../../../../../store/reducers/patientContext';
import moment from 'moment';

const HandoverButton = ({patient, disableSave, nurseHandover}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const value = (nurseHandover ? patient?.studies?.edau?.nurseHandover : patient?.handover) || {
        who: null,
        when: moment(),
        text: '',
    };

    return (
        <MainScreenButton
            value={value}
            filled={value && value.who && value.when}
            disabled={disableSave}
            label={t(`${nurseHandover ? 'Nurse ' : ''}Handover`)}
            onOpen={() => dispatch(openPatientForm(nurseHandover ? 'nurseHandover' : 'handover'))}
        />
    );
};

export default HandoverButton;